import { ApolloClient, ApolloLink, InMemoryCache } from "apollo-boost";
import { refreshTokenLink } from "api/client/refreshTokenLink";
import { authLink } from "api/client/authLink";
import { httpLink } from "api/client/httpLink";

const link = ApolloLink.from([authLink, refreshTokenLink, httpLink]);
const cache = new InMemoryCache();

export const client = new ApolloClient({ link, cache });
